export const PAGE_TITLE = 'בליבי - Belibi';

export const REDUX_STORAGE_KEY = '__REDUX_STORAGE';
export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export const SHARE_CONSTANTS = {
  TWITTER: 'Twitter',
  FACEBOOK: 'Facebook',
  MAIL: 'E-mail',
  WHATS_APP: 'whatsApp',
};

export const REG_EXP = {
  NUMBERS: /^[0-9\b]+$/,
  HEBREW_ONLY_LETTERS: /^[\u0590-\u05FF ,.'-]+$/i,
  HEBREW_WITH_NUMBERS: /^[\u0590-\u05FF 0-9 ,.'-]+$/,
  EMAIL: /[a-zA-Z@. 0-9]/,
};

export const DOMAIN_URL = 'https://belibi.org';

export const PRAYER_HUB_SHARE_TITLE = 'התפללו עבור ${name}'
export const PRAYER_HUB_SHARE_DESCRIPTION = 'הצטרפו לקהילת בליבי והקדישו רגע של תפילה, חיזוק ותקווה';